/* eslint-disable max-statements */
import React, {useState} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

import Slider from "react-slick";
// import CarImage from "./images/car-image.png";
import { GALLERY_TAB_TYPE } from "../car-detail-info/constant";
import { fastlyUrl, imageTypes } from "../../../utils/helpers/cdn-image-url";
import { getCDPAltText } from "../../../utils/helpers/get-cdp-alt-text";
import { MEDIA_SOURCE, NUMBER } from "../../../constants/app-constants";
import Three60 from "./images/three-sixty.png";
import Three60Active from "./images/three-sixty-active.png";
import VehicleInfoSection from "./vehicle-info-section";
import LockIcon from "./images/lock.svg";

const navigationElements = {
    tour: {
        key: GALLERY_TAB_TYPE.threeSixtyView,
        img: Three60,
        imgActive: Three60Active,
        label: "Tour",
        gaEvent: "360View"
    },
    exterior: {
        key: GALLERY_TAB_TYPE.exterior,
        img: null,
        label: "Exterior",
        gaEvent: "exterior"
    },
    interior: {
        key: GALLERY_TAB_TYPE.interior,
        img: null,
        label: "Interior",
        gaEvent: "interior"
    },
    noDefects: {
        key: GALLERY_TAB_TYPE.imperfections,
        img: null,
        label: "No Imperfections",
        gaEvent: "imperfections"
    },
    defects: {
        key: GALLERY_TAB_TYPE.imperfections,
        img: null,
        label: "Imperfections",
        gaEvent: "imperfections"
    }
};

const HeroSliderCdpRevamp = ({
    match: {
        params: { lid: carId }
    },
    content,
    openGalleryPopUp,
    imageHost
}) => {
    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();
    const { imperfectionImages, exteriorImages, interiorImages, threeSixtyViewUrl, mediaSource, make, model, year, variant, transmissionType, odometerReading, reserved  } = content || {};
    const exteriorImgGallery = (exteriorImages || []).map((image, index) => ({...image, tabName: "Exterior", imageIndex: index}));
    const interiorImgGallery = (interiorImages || []).map((image, index) => ({...image, tabName: "Interior", imageIndex: index}));
    const defectImgGallery = (imperfectionImages || []).map((image, index) => ({...image, tabName: "Imperfections", imageIndex: index}));
    const gallery = [...exteriorImgGallery, ...interiorImgGallery, ...defectImgGallery];
    const [activeTab, setActiveTab] = useState(navigationElements.exterior.key);

    const handleTab = (tabName = "") => {
        setActiveTab(tabName.toLowerCase());
    };

    const handleTabClick = (tabName) => {
        const selectedTab = tabName || GALLERY_TAB_TYPE.threeSixtyView;
        openGalleryPopUp(selectedTab, NUMBER.ZERO);
        handleTab(selectedTab);
    };

    const settingsSlider1 = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrow: true,
        dots: false,
        infinite: false,
        afterChange: (index) => {
            handleTab(gallery[Math.floor(index)].tabName, 0, index);
        },

        // eslint-disable-next-line no-shadow
        ref: slider1 => setNav1(slider1),
        asNavFor: nav2,
        lazyLoad: "ondemand"
    };

    const openThreeSixtyView = () => {
        handleTabClick(navigationElements.tour.key);
    };
    const altTextDetails = {
        year,
        make,
        model,
        variant,
        transmissionType,
        odometerReading
    };

    const handleHelloArTabClick = (tabName) => {
        if (tabName === navigationElements.exterior.key) {
            openGalleryPopUp(GALLERY_TAB_TYPE.exterior, 0);
        } else if (tabName === navigationElements.interior.key) {
            openGalleryPopUp(GALLERY_TAB_TYPE.interior, 0);
        } else if (tabName === navigationElements.defects.key) {
            openGalleryPopUp(GALLERY_TAB_TYPE.imperfections, 0);
        } else {
            openGalleryPopUp(threeSixtyViewUrl ? GALLERY_TAB_TYPE.threeSixtyView  : GALLERY_TAB_TYPE.exterior, 0);
        }
    };

    const updateActiveTab = (tabName) => {
        handleTab(tabName);
        if (mediaSource === MEDIA_SOURCE.s20) {
            handleTabClick(tabName);
        } else {
            handleHelloArTabClick(tabName);
        }
    };
    let carImperfectionsCount = 0;
    let carDefectCounterText = "";
    if (gallery) {
        gallery.forEach(element => {
            if (element.tabName.toLowerCase() === navigationElements.defects.key.toLowerCase())carImperfectionsCount += NUMBER.ONE;
        });
    }
    const navigationTabs = [
        navigationElements.tour,
        navigationElements.exterior,
        navigationElements.interior
    ];
    if (carImperfectionsCount > NUMBER.ZERO) {
        carDefectCounterText = `(${carImperfectionsCount})`;
        navigationTabs.push(navigationElements.defects);
    } else {
        navigationTabs.push(navigationElements.noDefects);
    }
    const onSliderScroll = () => {};

    const settingsSlider2 = {
        asNavFor: nav1,
        // eslint-disable-next-line no-shadow
        ref: slider2 => setNav2(slider2),
        swipeToSlide: true,
        focusOnSelect: true,
        lazyLoad: "ondemand",
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: false,
        arrow: false,
        dots: false,
        afterChange: onSliderScroll
    };
    return (
        <div>
            <div styleName={"styles.topSliderWrapper"}>
                <Slider {...settingsSlider1}>
                    {(gallery || []).map((image, index) => (
                        <img
                            key={index}
                            src={fastlyUrl(imageHost, image.path, imageTypes.carDetailHeroImage)}
                            alt={`${getCDPAltText(altTextDetails)}, ${image.label}`}
                            onClick={openThreeSixtyView}
                        />
                    ))}
                </Slider>
                <div styleName={"styles.topTabWrapper"}>
                    {navigationTabs.map((tab) => (
                        <p key={tab.key} styleName={`styles.tabName ${ activeTab === tab.key ? "styles.active" : ""}`} onClick={() => updateActiveTab(tab.key)}>
                            {tab ? tab.img && <img src={activeTab === tab.key ? tab.imgActive : tab.img} alt="" /> : ""}
                            {tab.label} {tab.key === navigationElements.defects.key ? <span>{carDefectCounterText}</span> : null}
                        </p>
                    ))}
                </div>
                {reserved && <div styleName={"styles.reservedCarWrap"}>
                    <p styleName={"styles.reserved"}><img src={LockIcon} alt="Reserved cars lock icon" />This car is currently reserved</p>
                </div>}
                <VehicleInfoSection carId={carId}/>
            </div>

            <div styleName="styles.sliderWrapper">
                <Slider {...settingsSlider2}>
                    {(gallery || []).map((item =>
                        (<div key={item.path}>
                            <img
                                src={fastlyUrl(imageHost, item.path, imageTypes.spinCarZoomable)}
                                alt={item.label}
                            />
                        </div>)
                    ))}
                </Slider>
            </div>
        </div>
    );
};
HeroSliderCdpRevamp.propTypes = {
    content: PropTypes.object,
    openGalleryPopUp: PropTypes.func,
    imageHost: PropTypes.string,
    isUserZeroDpVariant: PropTypes.bool,
    userTradeInData: PropTypes.object,
    tradeInToggleSelected: PropTypes.bool,
    reserved: PropTypes.bool,
    match: PropTypes.number
};

export default HeroSliderCdpRevamp;
